import React from 'react'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {ClientForm} from '../../shop/clients/components/ClientForm'
import {ModeleClient, modeleClientInitValues} from '../../../../components/Models'
import {createClient} from '../../../../components/requests'
import {savErreur} from '../../../../components/sav/requests'

type Props = {
  titre?: string
  // Valeurs préremplies (coordonnées de la personne d'un client générique)
  prerempli?: Partial<ModeleClient>
  onClose: () => void
  onCree: (clientId: number) => void
}

// Création d'une fiche client par le process client standard (formulaire et API client existants)
const SavClientCreateModal = ({
  titre = 'Création de client',
  prerempli = {},
  onClose,
  onCree,
}: Props) => {
  const soumettre = async (champs: Partial<ModeleClient>, callback: () => void) => {
    try {
      const reponse = await createClient(Object.assign({...modeleClientInitValues}, champs))
      if (reponse?.data?.id) {
        onCree(reponse.data.id)
      }
    } catch (e) {
      toast.error(savErreur(e, "La fiche client n'a pas pu être créée."))
    } finally {
      callback()
    }
  }

  return (
    <Modal show onHide={onClose} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>{titre}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ClientForm
          clientId={null}
          data={{...modeleClientInitValues, ...prerempli}}
          submitForm={soumettre}
          isCreateViaModal
        />
      </Modal.Body>
    </Modal>
  )
}

export default SavClientCreateModal
